<template>
    <div id="stripe-card">
        <div class="row">
            <label class="col-4">Cardholder name</label>
            <input class="col-8" type="text" name="card_name" placeholder="Richard Hendricks" v-model="form.cardName" ref="cardholder" />
        </div>
        <div class="row">
            <label class="col-4">Card number</label>
            <div class="col-8" ref="stripeNumber"></div>
        </div>
        <div class="row">
            <label class="col-4">Expiry date</label>
            <div class="col-8" ref="stripeExpiry"></div>
        </div>
        <div class="row">
            <label class="col-4">CVC</label>
            <div class="col-8" ref="stripeCvc"></div>
        </div>
        <div class="row">
            <label class="col-4">Postal code</label>
            <input class="col-8" type="text" name="zipcode" placeholder="90210" ref="stripeZip" v-model="form.cardZip" />
        </div>
        <div class="message-error" v-if="error">{{ error }}</div>
    </div>
</template>

<script>
// Thanks to https://jsfiddle.net/ywain/o2n3js2r/
const fieldsOrder = ['cardNumber', 'cardExpiry', 'cardCvc']

export default {
    props: {
        name: {
            default: null,
            required: false,
            type: String
        }
    },
    data () {
        return {
            error: null,
            stripe: {
                instance: null,
                cardNumber: null,
                cardExpiry: null,
                cardCvc: null
            },
            form: {
                cardName: null,
                cardZip: null
            }
        }
    },
    mounted () {
        const style = {
            base: {
                color: '#31325F',
                '::placeholder': {
                    color: '#CFD7E0'
                }
            }
        }

        this.stripe.instance = window.Stripe(window.stripe_api_key)
        const elements = this.stripe.instance.elements()
        this.stripe.cardNumber = elements.create('cardNumber', {
            showIcon: true,
            style
        })
        this.stripe.cardExpiry = elements.create('cardExpiry', { style })
        this.stripe.cardCvc = elements.create('cardCvc', { style })

        // Handle real-time validation errors from the card Element.
        this.stripe.cardNumber.addEventListener('change', this.onStripeChange)
        this.stripe.cardExpiry.addEventListener('change', this.onStripeChange)
        this.stripe.cardCvc.addEventListener('change', this.onStripeChange)
    },
    methods: {
        setFocus () {
            this.$refs.cardholder.focus()
        },
        onStripeChange (event) {
            this.error = null
            if (event.error) {
                this.error = event.error.message
                return false
            }

            if (event.complete) {
                const currentPosition = fieldsOrder.indexOf(event.elementType)
                if (currentPosition < fieldsOrder.length - 1) {
                    this.stripe[fieldsOrder[currentPosition + 1]].focus()
                } else {
                    this.$refs.stripeZip.focus()
                }
            }
        },
        reset () {
            this.form.cardName = this.name
            this.form.cardZip = null
            this.stripe.cardNumber.mount(this.$refs.stripeNumber)
            this.stripe.cardExpiry.mount(this.$refs.stripeExpiry)
            this.stripe.cardCvc.mount(this.$refs.stripeCvc)
        },
        setError (message) {
            this.error = message
        },
        async process () {
            const result = await this.stripe.instance.createToken(this.stripe.cardNumber, {
                name: this.form.cardName,
                address_zip: this.form.cardZip,
                currency: 'USD'
            })

            if (result.error) {
                // Inform the user if there was an error.
                this.error = result.error.message
                return null
            }

            return result.token.id
        }
    }
}
</script>

<style lang="scss" scoped>
    #stripe-card {
        min-height: 200px;
    }

    .row {
        border-bottom: 1px solid #F0F5FA;
        align-items: center;

        label {
            text-align: right;
            padding: 10px 0
        }

        input {
            border: none;
            border-radius: 0;
            padding: 10px;
            margin: 0;
            color: #31325F;
            &::placeholder {
                color: #CFD7E0;
            }
        }

        &>div {
            padding: 10px;
        }
    }

    .message-error {
        color: #eb1c26;
        background-color: rgba(#eb1c26, 5%);
        padding: 10px;
        border-radius: 5px;
        border: solid 1px rgba(#eb1c26, 30%);
        font-style: italic;
        width: 100%;
        text-align: center;
        margin: 0;
        animation: .5s ease-in-out 0s 1 forwards fadeInFromNone;
    }
</style>
